import { NgModule } from '@angular/core';

import { ConfidenceColorPipe } from './confidence-color.pipe';

@NgModule({
  imports: [],
  declarations: [ConfidenceColorPipe],
  exports: [ConfidenceColorPipe],
})
export class ConfidenceColorPipeModule {}
